import { h } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import * as BaseComp from 'base/bolt/boltApp.js';
// import s from 'base/bolt/boltApp.sss';
import ss from 'components/bolt/movieDetails/movieDetails.sss';
import ErrorOverlay from 'components/bolt/errorOverlay/errorOverlay';
import { joinClasses } from 'utils/utils';

export default class BoltApp extends BaseComp.default {

	constructor(props) {
		super(props);

		this.onShowNotSupportedError = this.onShowNotSupportedError.bind(this);
		this.hideErrorOverlay = this.hideErrorOverlay.bind(this);

		Store.on(actions.CAMERA_ACCESS_DENIED, this.onShowNotSupportedError);
		Store.on(actions.SHOW_NOT_SUPPORTED_ERROR, this.onShowNotSupportedError);
		Store.on(actions.HIDE_NOT_SUPPORTED_ERROR, this.hideErrorOverlay);
	}

	componentDidMount() {
		super.componentDidMount();

		this.state = {
			...this.state,
			showErrorOverlay: false,
		};
	}

	componentWillUnmount() {
		Store.off(actions.CAMERA_ACCESS_DENIED, this.onShowNotSupportedError);
		Store.off(actions.SHOW_NOT_SUPPORTED_ERROR, this.onShowNotSupportedError);
		Store.off(actions.HIDE_NOT_SUPPORTED_ERROR, this.hideErrorOverlay);
	}

	onShowNotSupportedError(type) {
		if (type === 'device') {
			Store.get().set({ showDeviceNotSupported: true });
		}
		if (type === 'camera') {
			Store.get().set({ showCameraPermissionsDenied: true });
		}
		this.showErrorOverlay();
	}

	showErrorOverlay() {
		this.setState({ showErrorOverlay: true });
	}

	hideErrorOverlay() {
		this.setState({ showErrorOverlay: false });
	}

	getExtra() {
		const { showErrorOverlay } = this.state;

		const store = this.state?.appState || {};
		const { showDeviceNotSupported, showCameraPermissionsDenied } = store;
		const imageRegionRoot = store?.appData?.urls?.roots?.imageRegion || '';
		const copy = store?.appData?.copy?.baseCopy || {};

		let title = copy.$NO_SUPPORT_MESSAGE;
		let description = copy.$NO_SUPPORT_CTA;
		if (showDeviceNotSupported) {
			title = copy.$NO_SUPPORT_MESSAGE;
			description = copy.$NO_SUPPORT_CTA;
		} else if (showCameraPermissionsDenied) {
			title = copy.$AR_CAMERA_PERMISSIONS_DENIED;
			description = copy.$AR_CAMERA_PERMISSIONS_DENIED_CONTENT;
		}

		return (
			<ErrorOverlay
				copy={copy}
				imageRegionRoot={imageRegionRoot}
				show={showErrorOverlay}
				isDeviceNotSupported={showDeviceNotSupported}
				cameraPermissionsDenied={showCameraPermissionsDenied}
				errorTitle={title}
				errorDescription={description}
				buttonClass={joinClasses(ss.button, ss.buttonLabel)}
				onBackClick={() => this.hideErrorOverlay()}
			/>
		);
	}
}
